import { Checkbox } from "@/components/ui/checkbox";

export const SHOWROOMS = [["Mumbai", ""], ["Bangalore", ""], ["Delhi", "Upcoming"], ["Hyderabad", "Upcoming"]];
export const STAY = [["showroom_news", "Showroom news & invitations"], ["new_products", "New products & collections"]];
const INTEREST = [["yes", "Yes"], ["later", "Perhaps later"], ["no", "No"]];

function Section({ title, children }) {
  return (
    <div className="space-y-2">
      <p className="text-[11px] uppercase tracking-widest text-slate-500 font-semibold">{title}</p>
      {children}
    </div>
  );
}

// Step-2 add-on: showroom visit intent, preferred locations, communication preferences
export function ShowroomBlock({ value, onChange }) {
  const v = { interest: "", locations: [], stay: [], ...value };
  const set = (patch) => onChange({ ...v, ...patch });
  const toggle = (key, item) => set({ [key]: v[key].includes(item) ? v[key].filter((x) => x !== item) : [...v[key], item] });
  return (
    <div className="mt-5 grid gap-5 sm:grid-cols-2" data-testid="ld-showroom-block">
      <Section title="Showroom visit">
        <p className="text-sm text-slate-700">Would you be interested in visiting a UniVicoustic showroom?</p>
        <div className="flex flex-wrap gap-2" role="radiogroup" data-testid="ld-showroom-interest">
          {INTEREST.map(([k, label]) => (
            <button key={k} type="button" role="radio" aria-checked={v.interest === k} onClick={() => set({ interest: v.interest === k ? "" : k })}
              className={`rounded-full border px-3.5 py-1.5 text-sm transition-colors ${v.interest === k ? "border-brand bg-brand-soft/70 text-slate-900 font-medium" : "border-slate-200 bg-white text-slate-600 hover:border-slate-400"}`}
              data-testid={`ld-showroom-${k}`}>{label}</button>
          ))}
        </div>
        <p className="text-sm text-slate-700 pt-1">Which showroom location would be relevant to you?</p>
        <div className="grid grid-cols-2 gap-1.5" data-testid="ld-showroom-locations">
          {SHOWROOMS.map(([city, tag]) => (
            <label key={city} className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
              <Checkbox checked={v.locations.includes(city)} onCheckedChange={() => toggle("locations", city)} data-testid={`ld-showroom-loc-${city.toLowerCase()}`} />
              {city}{tag && <span className="text-[10px] uppercase tracking-wider text-amber-600 font-semibold">· {tag}</span>}
            </label>
          ))}
        </div>
      </Section>
      <Section title="Stay connected">
        <div className="space-y-1.5" data-testid="ld-stay-connected">
          {STAY.map(([k, label]) => (
            <label key={k} className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
              <Checkbox checked={v.stay.includes(k)} onCheckedChange={() => toggle("stay", k)} data-testid={`ld-stay-${k}`} />{label}
            </label>
          ))}
        </div>
      </Section>
    </div>
  );
}

export const showroomLabel = (k) => ({ yes: "Yes", later: "Perhaps later", no: "No" }[k] || "");
export const stayLabel = (k) => Object.fromEntries(STAY)[k] || k;
